import requestCodeDetails from './request-code.details';

export const RequestCodeStores = {
  detail: requestCodeDetails,
};
